import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PaymentsIcon from "@mui/icons-material/Payments";
import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import OpenInNewOffIcon from "@mui/icons-material/OpenInNewOff";
import PaidIcon from "@mui/icons-material/Paid";

// Única fuente de verdad de "qué acciones tiene disponibles un pedido según
// la pestaña en la que está". La usan tanto la tabla (menú de 3 puntos) como
// las tarjetas (botón principal + menú), así nunca quedan desincronizadas.
// `abrirModal(key, pedido)` es el único efecto que dispara cada acción.
export const getAccionesPedido = (activeTab, pedido, abrirModal) => {
  const acciones = [];

  if (activeTab === 0 && pedido.estado !== 351) {
    acciones.push({
      key: "asignar",
      label: "Asignar Chofer",
      icon: LocalShippingIcon,
      color: "secondary",
      onClick: () => abrirModal("asignar", pedido),
    });
  }

  if (activeTab === 0 && pedido.link_pago === 0) {
    acciones.push({
      key: "linkPago",
      label: "Generar link de pago",
      icon: PaymentsIcon,
      color: "success",
      onClick: () => abrirModal("linkPago", pedido),
    });
  }

  if (activeTab === 0 && pedido.link_pago === 1) {
    acciones.push({
      key: "verLink",
      label: "Ver link de pago",
      icon: PaymentsIcon,
      color: "success",
      onClick: () => abrirModal("verLink", pedido),
    });
  }

  if (activeTab === 1) {
    acciones.push({
      key: "reasignar",
      label: "Reasignar Chofer",
      icon: LocalShippingIcon,
      color: "secondary",
      onClick: () => abrirModal("asignar", pedido),
    });
  }

  if (activeTab === 0 || activeTab === 1) {
    acciones.push({
      key: "anular",
      label: "Anular Pedido",
      icon: BlockIcon,
      color: "error",
      onClick: () => abrirModal("anularPedido", pedido),
    });
  }

  if ((activeTab === 0 && pedido.estado !== 351) || activeTab === 1) {
    acciones.push({
      key: "editar",
      label: "Editar Pedido",
      icon: EditIcon,
      color: "primary",
      disabled: pedido.estado === 351,
      onClick: () => abrirModal("editarPedido", pedido),
    });
  }

  if (activeTab === 1) {
    acciones.push({
      key: "reclamar",
      label: "Pedido Reclamado",
      icon: ReportGmailerrorredIcon,
      color: "warning",
      onClick: () => abrirModal("reclamarPedido", pedido),
    });
  }

  if (activeTab === 2) {
    acciones.push({
      key: "reabrir",
      label: "Reabrir Pedido",
      icon: OpenInNewOffIcon,
      color: "action",
      onClick: () => abrirModal("reabrir", pedido),
    });
  }

  if (activeTab === 3) {
    acciones.push({
      key: "facturar",
      label: "Facturar Pedido",
      icon: PaidIcon,
      color: "success",
      onClick: () => abrirModal("facturar", pedido),
    });
    acciones.push({
      key: "anular",
      label: "Anular Pedido",
      icon: BlockIcon,
      color: "error",
      onClick: () => abrirModal("anularPedido", pedido),
    });
  }

  return acciones;
};

// Para las tarjetas: la primera acción de la lista es la más relevante para
// esa pestaña (asignar / reasignar / reabrir / facturar) y se muestra como
// botón principal; el resto queda en el menú secundario.
export const getAccionPrincipal = (acciones) => acciones[0] || null;
export const getAccionesSecundarias = (acciones) => acciones.slice(1);
